import React, { useState, useEffect } from 'react'
import { TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setState, setTotalValues } from "./defineSlice";
import { formatNumber, removeComma } from "./defineUtils";

export default function TableCellAdjustment(params) {
   const dispatch = useDispatch();
   const define = useSelector((state) => state.define);
   const {
      gridData,
      gridDataFiltered,
      weeklyDepletionValues,
      selectedDepletion,
   } = define;
   const { week1, week2, week3, week4, week5 } = weeklyDepletionValues;
   const [adjustment, setAdjustment] = useState(params.row.adjustment);
   useEffect(()=>{
      setAdjustment(params.row.adjustment);
   },[params.row.adjustment])

   function updateGrid(adjust, updatedQuota, w1, w2, w3, w4, w5) {
      const customerID = params.row.customerID;
      const customerGroupID = params.row.customerGroupID;
      const productGroupID = params.row.productGroupID;
      const skuid = params.row.skuid;
      let updatedItem = null;
      const updated = gridDataFiltered.map((item, index) => {
         const flag =
            item.customerID === customerID &&
            item.customerGroupID === customerGroupID &&
            item.productGroupID === productGroupID &&
            item.skuid === skuid;
         if (flag === true) {
            updatedItem = {
               ...item,
               adjustment: adjust,
               quota: updatedQuota,
               weekly1: !w1 ? 0 : w1,
               weekly2: !w2 ? 0 : w2,
               weekly3: !w3 ? 0 : w3,
               weekly4: !w4 ? 0 : w4,
               weekly5: !w5 ? 0 : w5,
            };
            return updatedItem;
         }
         return item;
      });

      const updatedGrid = [];
      for (let i = 0; i < gridData.length; ++i) {
         const item = gridData[i];
         if (item.id === updatedItem.id) {
            updatedGrid.push(updatedItem);
         } else {
            updatedGrid.push(item);
         }
      }

      dispatch(setState("gridDataFiltered", updated));
      dispatch(setState("gridData", updatedGrid));
      dispatch(setTotalValues());
   }

   function updateAdjustmentTemp(adjust) {
      const customerID = params.row.customerID;
      const customerGroupID = params.row.customerGroupID;
      const productGroupID = params.row.productGroupID;
      const skuid = params.row.skuid;
      let updatedItem = null;
      const updated = gridDataFiltered.map((item, index) => {
         const flag =
            item.customerID === customerID &&
            item.customerGroupID === customerGroupID &&
            item.productGroupID === productGroupID &&
            item.skuid === skuid;
         if (flag === true) {
            updatedItem = {
               ...item,
               adjustment: adjust,
            };
            return updatedItem;
         }
         return item;
      });

      const updatedGrid = [];
      for (let i = 0; i < gridData.length; ++i) {
         const item = gridData[i];
         if (item.id === updatedItem.id) {
            updatedGrid.push(updatedItem);
         } else {
            updatedGrid.push(item);
         }
      }

      dispatch(setState("gridDataFiltered", updated));
      dispatch(setState("gridData", updatedGrid));
   }

   function updateAdjustment(event) {
      let adjustStr = removeComma(event.target.value);
      let previousAdj = adjustment;
      if(adjustStr === "0-") {
         adjustStr = "-";
      }
      let adjust = Number(adjustStr);

      if (!isNaN(adjust)) {
         setAdjustment(adjust);
         dispatch(setState("gridDataChanged", true));
         const initialQuota = Number(params.row.initialQuota);
         const safetyMargin = Number(params.row.safetyMargin);
         const val =
            initialQuota === 0 ? 0 : (safetyMargin / 100) * initialQuota;
         const updatedQuota = Math.round(initialQuota + val + adjust);
         console.log(
            `Quota Calculation: ${initialQuota} + (( ${safetyMargin} / 100 ) * ${initialQuota}) + ${adjust}`
         );
         
         if(updatedQuota < 0) {
            dispatch(setState("isError", true));
            dispatch(setState("isError_Info", "Quota can not be negative."));
            if(previousAdj === "-"){
               const initialQuota = Number(params.row.initialQuota);
               const safetyMargin = Number(params.row.safetyMargin);
               const val = initialQuota === 0 ? 0 : (safetyMargin / 100) * initialQuota;
               const updatedQuota = Math.round(initialQuota + val + 0);
               if(updatedQuota >= 0) {
                  setAdjustment(0);
                  let w1 = 0;
                  let w2 = 0;
                  let w3 = 0;
                  let w4 = 0;
                  let w5 = 0;
                  if (selectedDepletion.key === "None") {
                     w1 = updatedQuota;
                  } else if (selectedDepletion.key === "biweekly") {
                     w1 = Math.round(updatedQuota * week1);
                     if (w1 > updatedQuota) {
                        w1 = updatedQuota;
                     }
                     // w2 = w1 + Math.round(updatedQuota * week2);
                     w2 = updatedQuota;
                  } else if(selectedDepletion.key === "depletion_80_20"){
                     w1 = Math.round(updatedQuota * week1);
                     if (w1 > updatedQuota) {
                        w1 = updatedQuota;
                     }
                     w2 = Math.round(updatedQuota * week2);
                     if (w2 > updatedQuota) {
                        w2 = updatedQuota;
                     }
                     w3 = Math.round(updatedQuota * week3);
                     if (w3 > updatedQuota) {
                        w3 = updatedQuota;
                     }
                     w4 = Math.round(updatedQuota * week4);
                     if (w4 > updatedQuota) {
                        w4 = updatedQuota;
                     }
                     w5 = Math.round(updatedQuota * week5);
                     if(w5 !== 0){
                        w5 = updatedQuota;
                     }else{
                        w4 = updatedQuota;
                        w5 = updatedQuota;
                     }
                  }
                  else {
                     w1 = Math.round(updatedQuota * week1);
                     if (w1 > updatedQuota) {
                        w1 = updatedQuota;
                     }
                     w2 = w1 + Math.round(updatedQuota * week2);
                     if (w2 > updatedQuota) {
                        w2 = updatedQuota;
                     }
                     w3 = w2 + Math.round(updatedQuota * week3);
                     if (w3 > updatedQuota) {
                        w3 = updatedQuota;
                     }
                     w4 = w3 + Math.round(updatedQuota * week4);
                     if (w4 > updatedQuota) {
                        w4 = updatedQuota;
                     }
                     w5 = Math.round(updatedQuota * week5);
                     if(w5 !== 0){
                        w5 = updatedQuota;
                     }else{
                        w4 = updatedQuota;
                        w5 = updatedQuota;
                     }
                  }
                  updateGrid(0, updatedQuota, w1, w2, w3, w4, w5);
               }
            } else {
               setAdjustment(previousAdj);
            }
            return;
         }

         let w1 = 0;
         let w2 = 0;
         let w3 = 0;
         let w4 = 0;
         let w5 = 0;
         if (selectedDepletion.key === "None") {
            w1 = updatedQuota;
         } else if (selectedDepletion.key === "biweekly") {
            w1 = Math.round(updatedQuota * week1);
            if (w1 > updatedQuota) {
               w1 = updatedQuota;
            }
            // w2 = w1 + Math.round(updatedQuota * week2);
            w2 = updatedQuota;
         } else if(selectedDepletion.key === "depletion_80_20"){
            w1 = Math.round(updatedQuota * week1);
            if (w1 > updatedQuota) {
               w1 = updatedQuota;
            }
            w2 = Math.round(updatedQuota * week2);
            if (w2 > updatedQuota) {
               w2 = updatedQuota;
            }
            w3 = Math.round(updatedQuota * week3);
            if (w3 > updatedQuota) {
               w3 = updatedQuota;
            }
            w4 = Math.round(updatedQuota * week4);
            if (w4 > updatedQuota) {
               w4 = updatedQuota;
            }
            w5 = Math.round(updatedQuota * week5);
            if(w5 !== 0){
               w5 = updatedQuota;
            }else{
               w4 = updatedQuota;
               w5 = updatedQuota;
            }
         }
         else {
            w1 = Math.round(updatedQuota * week1);
            if (w1 > updatedQuota) {
               w1 = updatedQuota;
            }
            w2 = w1 + Math.round(updatedQuota * week2);
            if (w2 > updatedQuota) {
               w2 = updatedQuota;
            }
            w3 = w2 + Math.round(updatedQuota * week3);
            if (w3 > updatedQuota) {
               w3 = updatedQuota;
            }
            w4 = w3 + Math.round(updatedQuota * week4);
            if (w4 > updatedQuota) {
               w4 = updatedQuota;
            }
            w5 = Math.round(updatedQuota * week5);
            if(w5 !== 0){
               w5 = updatedQuota;
            }else{
               w4 = updatedQuota;
               w5 = updatedQuota;
            }
         }

         console.log(
            `week1 ${w1}, week2 ${w2}, week3 ${w3}, week4 ${w4}, week5 ${w5}, updated quota ${updatedQuota}`
         );

         updateGrid(adjust, updatedQuota, w1, w2, w3, w4, w5);

      } else if (isNaN(adjust) && adjustStr.length === 1) {
         dispatch(setState("gridDataChanged", true));
         updateAdjustmentTemp(adjustStr);
      } else {
         dispatch(setState("isError", true));
         dispatch(setState("isError_Info", "Only numbers are allowed."));
      }
   }

   return (
      <TextField
         variant="standard"
         value={adjustment?.toLocaleString('en-US')}
         onChange={updateAdjustment}
         sx={{ width: 100 }}
         inputProps={{ style: {textAlign: 'center' } }}
      />
   );
}
